import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import { RootState, store } from "store";

export type AppDispatch = typeof store.dispatch;
export type AppSelector = TypedUseSelectorHook<RootState>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: AppSelector = useSelector;
